import { styled } from 'styled-components';

export const UserPageWrap = styled.div`
  margin: 0px;
  display: flex;
  gap: 20px;
  padding: 20px;
`;
export const UserPageContent = styled.div`
  color: black;
  width: 100%;
`;
export const UserPageContentWrap = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: 15px;
`;
export const UserInfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  height: 100%;
  width: 100%;
`;
export const UserPageTable = styled.table`
  width: 100%;
  max-width: 90%;
  border-collapse: separate;
  border-spacing: 0px 20px;
`;
export const UserPageTableRow = styled.tr`
  text-align: left;
`;
